export default "__VITE_ASSET__6cba5148__"